// extracted by mini-css-extract-plugin
module.exports = {"container":"ModifyBillingSucccess_container__lajBD","msg":"ModifyBillingSucccess_msg__1PWBI","confirmBtn":"ModifyBillingSucccess_confirmBtn__2T8XX"};